module.exports = __webpack_public_path__ + "static/media/varsity_sleuth_father.e00449ac.png";